(() => {
  let merchantLabels={};try{merchantLabels=JSON.parse(document.querySelector('[data-orli-builder-config]')?.textContent||'{}').labels||{};}catch{}
  const settings=Object.freeze({searchLabel:'Find your charm',searchPlaceholder:'Search',requiredLabel:'Required',removeLabel:'Remove',confirmLabel:'Use this option',...merchantLabels});
  const currency=document.querySelector('[data-ocp-embedded]')?.dataset.currency||'GBP';
  const money=new Intl.NumberFormat('en-GB',{style:'currency',currency});
  const make=(tag,cls,text)=>{const node=document.createElement(tag);if(cls)node.className=cls;if(text!==undefined)node.textContent=text;return node;};
  const badge=heading=>heading.append(document.createTextNode(' '),make('span','ocm-required-badge',settings.requiredLabel));
  let imagePresentation={};try{imagePresentation=JSON.parse(document.querySelector('[data-orli-image-presentation]')?.textContent||'{}');}catch{}
  const resolveImage=url=>imagePresentation[url]?.image||url;
  const image=(value,size=160)=>{
    if(!value?.image&&!value?.preview_asset)return make('span','ocm-placeholder','◇');
    const img=make('img'),url=new URL(resolveImage(value.preview_asset?'orli-asset:'+value.preview_asset:value.image),location.origin);
    if(url.hostname==='cdn.shopify.com')url.searchParams.set('width',String(size*2));
    img.src=url.href;img.alt=value.label.trim();img.width=size;img.height=size;img.loading='lazy';img.decoding='async';
    const zoom=Number(imagePresentation[value.image]?.zoom||1);if(zoom>1){const frame=make('span','ocp-image-frame');img.style.transform=`scale(${zoom})`;frame.append(img);return frame;}return img;
  };
  function priceController(root){
    const product=root.closest('[id^="MainProduct--"]'),wrapper=product?.querySelector('[id^="Price-"]');
    const enabled=/^[A-Z]{3}$/.test(root.dataset.currency||'GBP');
    let prices={};try{prices=JSON.parse(root.querySelector('[data-orli-variant-prices]')?.textContent||'{}');}catch{}
    let titles={};try{titles=JSON.parse(root.querySelector('[data-orli-variant-titles]')?.textContent||'{}');}catch{}
    let extra=0;
    const variant=()=>product?.querySelector('form[action*="/cart/add"] [name="id"]')?.value;
    const base=()=>Number(prices[variant()]??root.dataset.basePrice);
    const total=()=>base()+extra;
    function renderPayments(){
      if(!enabled||!product)return;
      let changed=false;
      for(const placement of product.querySelectorAll('klarna-placement[data-purchase-amount]')){
        const amount=String(total());
        if(placement.dataset.purchaseAmount!==amount){placement.dataset.purchaseAmount=amount;changed=true;}
      }
      if(changed){
        if(typeof window.KOSMApp?.updatePurchaseAmount==='function')window.KOSMApp.updatePurchaseAmount(total());
        else window.KlarnaOnsiteService?.push({eventName:'refresh-placements'});
      }
    }
    function render(){
      if(!enabled||!wrapper)return;
      const block=wrapper.querySelector('.product__price');if(!block)return;
      block.classList.add('ocm-price-active');
      for(const container of block.querySelectorAll('.price__regular,.price__sale')){
        let amount=container.querySelector('.ocm-main-price');
        if(!amount){amount=make('span','ocm-main-price');container.append(amount);}
        const formatted=money.format(total()/100);if(amount.textContent!==formatted)amount.textContent=formatted;
        const original=container.querySelector(container.classList.contains('price__sale')?'.price-item--sale':'.price-item--regular');
        const originalAmount=original?.querySelector('.money')||original;
        if(originalAmount&&originalAmount.textContent!==formatted)originalAmount.textContent=formatted;
      }
      renderPayments();
    }
    if(enabled&&wrapper)new MutationObserver(render).observe(wrapper,{childList:true,subtree:true,characterData:true});
    if(enabled&&product)new MutationObserver(()=>requestAnimationFrame(renderPayments)).observe(product,{childList:true,subtree:true,attributes:true,attributeFilter:['data-purchase-amount']});
    product?.addEventListener('change',()=>requestAnimationFrame(render));
    return {set(amount){extra=amount;render();},total,enabled,variantTitle:()=>titles[variant()]||'',format:amount=>money.format(amount/100)};
  }
  const root=document.querySelector('[data-ocp-embedded]'),product=root?.closest('[id^="MainProduct--"]');
  let fileBindings=new Map();
  const mainForm=()=>product?.querySelector('product-form form[action*="/cart/add"]');
  let policy={};try{policy=JSON.parse(root?.querySelector('[data-orli-native-policy]')?.textContent||'{}');}catch{}
  let componentPolicy={};try{componentPolicy=JSON.parse(root?.querySelector('[data-orli-component-policy]')?.textContent||'{}');}catch{}
  let componentAvailable=componentPolicy.variants||{},componentSignature=null,componentReady=false,componentSubmitting=false,componentRequest=0;
  const paidSelections=()=>JSON.parse(root?.dataset.paidSelections||'[]');
  const loadComponents=componentPolicy.enabled===true?window.OrliPersonalisationCommerce.availability({components:window.OrliPersonalisationComponents||{},currency}):null;
  let marketQuotes;
  async function prepareData(data){
    if(window.OrliBuilderConfig){try{data=window.OrliBuilderConfig.prepare(data);}catch(error){root.dataset.configurationError='true';componentMessage('Personalisation is temporarily unavailable. Please contact us for help.');console.error('Orli builder configuration:',error);guard();throw error;}}
    if(currency==='GBP'||!loadComponents)return data;
    root.setAttribute('aria-busy','true');componentMessage('Loading your options…');
    try{
      marketQuotes||=loadComponents.catalogue();
      const result=window.OrliPersonalisationCommerce.presentment({data,components:window.OrliPersonalisationComponents,quotes:await marketQuotes,currency,material:root.dataset.componentMetal});
      Object.assign(window.OrliPersonalisationComponents,result.components);componentMessage('');return result.data;
    }finally{root.removeAttribute('aria-busy');}
  }
  const componentMessage=(message,retry=false)=>{
    if(!root)return;
    let node=root.querySelector('[data-orli-component-message]');
    if(!node){node=make('p','ocm-price-summary');node.dataset.orliComponentMessage='';node.setAttribute('role','status');root.append(node);}
    if(node.textContent!==message)node.textContent=message;
    if(node.hidden!==!message)node.hidden=!message;
    let button=root.querySelector('[data-orli-component-retry]');
    if(retry&&!button){button=make('button','ocm-remove','Try again');button.type='button';button.dataset.orliComponentRetry='';button.addEventListener('click',()=>checkComponents(true));root.append(button);}
    if(button&&button.hidden!==!retry)button.hidden=!retry;
  };
  function checkComponents(force=false){
    if(!loadComponents||!root)return;
    const signature=root.dataset.paidSelections||'[]';
    if(!force&&componentSignature===signature)return;
    const request=++componentRequest;
    componentSignature=signature;componentReady=false;componentAvailable={};
    let selections;try{selections=paidSelections();}catch{componentMessage('Please check your selected options.');return;}
    if(!selections.length){componentReady=true;componentMessage('');return;}
    componentMessage('Checking your selected options…');guard();
    return loadComponents(selections,force).then(available=>{
      if(componentSignature!==signature||componentRequest!==request)return;
      componentAvailable=available;componentReady=true;componentMessage('');
    }).catch(()=>{if(componentSignature===signature&&componentRequest===request)componentMessage('We couldn’t check your selected options. Please try again, or choose another option.',true);})
      .finally(()=>{if(componentSignature===signature&&componentRequest===request){root.dataset.nativeCartReady=String(canSubmit());guard();}});
  }
  const componentPlan=(group='preview')=>{
    if(componentPolicy.enabled!==true||!componentReady)return null;
    if(typeof policy.product_title!=='string'||!policy.product_title.trim())throw Error('The jewellery details could not be checked.');
    const form=mainForm(),original=new FormData(form),properties={};
    for(const [name,value] of original){const match=name.match(/^properties\[(.*)\]$/);if(match)properties[match[1]]=value;}
    Object.assign(properties,JSON.parse(root.dataset.orderProperties||'{}'));
    for(const [name,file] of fileBindings)if(Object.hasOwn(properties,name))properties[name]=file;
    return window.OrliPersonalisationCommerce.plan({variant:original.get('id'),quantity:Number(original.get('quantity')||1),properties,
      selections:paidSelections(),expectedExtra:Number(root.dataset.additionalPrice),
      available:componentAvailable,components:window.OrliPersonalisationComponents||{},currency:root.dataset.currency||'GBP',
      complete:root.dataset.selectionComplete==='true',group,parentTitle:policy.product_title});
  };
  const canSubmit=()=>{
    if(window.OrliDraftPreview?.active)return false;
    if(root?.dataset.configurationError==='true'||root?.dataset.selectionComplete!=='true'||policy.variants?.[mainForm()?.querySelector('[name="id"]')?.value]!==true)return false;
    if(componentPolicy.enabled===true){try{return !!componentPlan();}catch{return false;}}
    return (policy.test_enabled===true||policy.file_test_enabled===true)&&Number(root.dataset.additionalPrice)===0&&root.dataset.fileBindingError!=='true';
  };
  const preservePrivateView=new URL(location.href).searchParams.get('view')==='orli-charm-native';
  const guard=()=>{
    product?.querySelectorAll('[name="add"]').forEach(button=>{const disabled=componentSubmitting||!canSubmit()||button.classList.contains('is-loading');if(button.disabled!==disabled)button.disabled=disabled;});
    const url=new URL(location.href);if(preservePrivateView&&!url.searchParams.has('view')){url.searchParams.set('view','orli-charm-native');history.replaceState(history.state,'',url);}
  };
  function syncForm(widget){
    const form=mainForm();
    if(widget!==root||!form)return;
    let properties={};try{properties=JSON.parse(widget.dataset.orderProperties||'{}');}catch{}
    const existing=new Map(Array.from(form.querySelectorAll('[data-orli-native-property]')).map(input=>[input.dataset.orliNativeProperty,input]));
    for(const [key,input] of existing)if(!Object.hasOwn(properties,key)){input.remove();existing.delete(key);}
    if(componentPolicy.enabled!==true&&(policy.test_enabled===true||policy.file_test_enabled===true)&&Number(widget.dataset.additionalPrice)===0){
      widget.dataset.fileBindingError='false';
      for(const [key,value] of Object.entries(properties)){
        let input=existing.get(key);const file=fileBindings.get(key),type=file?'file':'hidden';
        if(input&&input.type!==type){input.remove();input=null;}
        if(!input){input=make('input');input.type=type;input.hidden=true;input.dataset.orliNativeProperty=key;input.name=`properties[${key}]`;form.append(input);}
        if(file){
          if(input.files?.[0]!==file){try{const transfer=new DataTransfer();transfer.items.add(file);input.files=transfer.files;}catch{widget.dataset.fileBindingError='true';}}
        }else if(input.value!==String(value))input.value=String(value);
      }
    }else form.querySelectorAll('[data-orli-native-property]').forEach(input=>input.remove());
    checkComponents();widget.dataset.nativeCartReady=String(canSubmit());guard();
  }
  if(product){
    product.addEventListener('submit',async event=>{
      if(event.target!==mainForm())return;
      if(!canSubmit()){event.preventDefault();event.stopImmediatePropagation();return;}
      if(componentPolicy.enabled===true||fileBindings.size){
        event.preventDefault();event.stopImmediatePropagation();
        const form=mainForm();if(!form.checkValidity()){form.reportValidity();return;}
        const button=event.submitter||form.querySelector('[name="add"]'),cart=document.querySelector('cart-items');
        if(!cart?.addToCart||componentSubmitting||button?.classList.contains('is-loading'))return;
        componentSubmitting=true;guard();
        const signature=componentSignature;
        try{
          if(loadComponents){
            componentAvailable=await loadComponents(paidSelections(),true);
            if(signature!==componentSignature)return;
          }
          const body=componentPolicy.enabled===true
            ?window.OrliPersonalisationCommerce.formData(componentPlan(crypto.randomUUID()),new FormData(form))
            :new FormData(form);
          window.a11y&&(window.a11y.lastElement=button);cart.addToCart(body,button);
        }catch{
          componentReady=false;root.dataset.nativeCartReady='false';componentMessage('We couldn’t check your selected options. Please try again before adding them.',true);
        }finally{componentSubmitting=false;guard();}
      }
    },true);
    guard();new MutationObserver(()=>syncForm(root)).observe(product,{subtree:true,childList:true,attributes:true,attributeFilter:['disabled','class']});
  }
  window.OrliPersonalisation={settings,money,make,badge,image,resolveImage,priceController,syncForm,prepareData,fail(){componentMessage('We couldn’t load your options. Please refresh the page and try again.');},setFiles(widget,files){if(widget===root)fileBindings=new Map(files);}};
})();
